import React from 'react';
import {Link} from 'react-router-dom';
import constants from '../../constants';
import CheckedSmallIcon from '../Icons/CheckedSmall';
import './style.scss';

const PersonalDataAgree = (props) => {
  return (
    <div className='personal-data-agree'>
      <div className='personal-data-agree__icon'><CheckedSmallIcon /></div>
      <div className='personal-data-agree__text'>
        Соглашаюсь с условиями <Link
          className='link'
          to={constants.ROUTES.PERSONAL_DATA_PAGE_PATH}
          onClick={() => props.onClick && props.onClick()}
        >
          Политики в отношении обработки персональных данных
        </Link>
      </div>
    </div>
  );
}

export default PersonalDataAgree;
